<template>
    <iv-modal
        title="修改舆情"
        :width="width"
        :closable="false"
        v-model="sources.shown"
        @on-cancel="onCancel"
    >
    <template v-if="value">
        <iv-row>
            <iv-col span="24">
                <h5 class="adm-content-item__title">
                    <a :href="value.url" target="_blank" rel="noopener noreferrer">
                    <span style="vertical-align: text-top;color:#3C3C3C;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;max-width: 350px;display: inline-block;">{{ !!value.title ? value.title : ''}}</span>
                        <span class="adm-content-item__type" title="在新窗口打开">
                            <iv-icon type="md-open" size="16"/>
                        </span>
                    </a>
                    <span class="pull-right" style="line-height: 20px;" v-if="type=='audit'">
                        <span class="adm-split">
                            <span class="t-s">
                            <iv-poptip v-if="value.audit==2" trigger="hover" title="审核批注" placement="left">
                                <iv-icon type="ios-information" size="12" style="color:#2d8cf0"></iv-icon>
                                <div slot="content" v-html="value.comment.replace(/\n/g,'<br>')"></div>
                            </iv-poptip>
                            {{ ['','未审核','不通过','已通过'][value.audit] }}
                            </span>
                        </span>
                    </span>
                </h5>
                <span style="font-weight:normal;mergin-left:50px">（发布于{{value.postTime | timesify}}）</span>
            </iv-col>
        </iv-row>
        <iv-row style="margin-top:30px" v-if="sources.sentimentData">
            <iv-col span="8">
                <span style="line-height: 25px;">二级指标：</span>
                <iv-select v-model="sources.sentimentData.secondTargetNum" size="small" style="width:100px" @on-change="refreshthirdTarget({ secondTargetNum : sources.sentimentData.secondTargetNum });UpdateThirdTargetNum()">
                    <iv-option v-for="item in options.secondTargets" :value="item.id" :key="item.id">{{ item.name }}</iv-option>
                </iv-select>
            </iv-col>
            <iv-col span="8">
                <span style="line-height: 25px;">三级指标：</span>
                <iv-select v-model="sources.sentimentData.thirdTargetNum" size="small" style="width:180px" @on-change="UpdateThirdTargetNum()">
                    <iv-option v-for="item in options.thirdTargets" :value="item.id" :key="item.id">{{ item.name }}</iv-option>
                </iv-select>
            </iv-col>
        </iv-row>
        <iv-row style="margin-top:30px">
            <iv-col span="24">
                <span style="line-height: 25px;">分析维度：</span>
                <iv-table
                    border
                    class="adm-table"
                    :columns="columns"
                    :data="list.dimensionInfo">
                </iv-table>
            </iv-col>
        </iv-row>
    </template>
        <iv-button type="text" size="large" slot="footer" @click="onCancel">关闭</iv-button>
    </iv-modal>
</template>
<script>
import Vue from "vue";
import { BusinessError, RequestError, isNumber} from '@/utils/';
import ModelMixin from "@/mixins/Model.mixin";
import LoaderMixin from "@/mixins/Loader.mixin";
import contact from "@/utils/contact";
import ListedTargetModel from "@/models/ListedTargetModel";
import ListedSentimentModel  from '@/models/ListedSentimentModel';

const FORM_NAME = `${LISTED_SENTIMENT}Form`;
const LISTED_TARGET = ListedTargetModel.ModelName;
const LISTED_SENTIMENT = ListedSentimentModel.ModelName;

function columns(vm){
        return  [
            {
                title: "分析维度",
                key: "dimension",
                align: "center",
                minWidth: 60,

            },
            {
                title: "得分",
                key: "abbreviation",
                align: "center",
                minWidth: 120,
                 render(h, params){
                    var dimensionScore = params.row.dimensionScore ? params.row.dimensionScore : 0;
                    const $inputNumber = <iv-input-number min={0} max={params.row.dimensionWeight} v-model={dimensionScore} onInput={ ()=>vm.dimension(params.row, dimensionScore )}></iv-input-number>
                    return <div>{ $inputNumber }</div>
                }
            },
            {
                title: "评分说明",
                key: "dimensionRuleExplain",
                align: "center",
                minWidth: 150,
            }
        ]
}
export default {
    mixins: [
        LoaderMixin(LISTED_TARGET,LISTED_SENTIMENT),
        ModelMixin({
            contact,
            models: [ListedTargetModel,ListedSentimentModel],
        }),
    ],
    props: {
        width: {
            type: [String, Number],
            default: "500",
        },
        value: {
            type: Object,
            default: null,
        },
         type: {
            type: String,
            default: "draft" //可选：draft, audit；draft为收录入前的草稿，audit为收录后的样式
        },
        shown: Boolean,
    },
    watch: {
        shown(val) {
            this.sources.shown = val;
            this.list = {
               dimensionInfo: []
            }
            if(!val) this.sources.sentimentData = null
        },
        async value(val) {
            this.sources.sentimentData = val;
            this.list.dimensionInfo = val.dimensionInfo
            if(this.sources.sentimentData.secondTargetNum)
                await this.refreshthirdTarget({ secondTargetNum : this.sources.sentimentData.secondTargetNum })
        },
    },
    data() {
        return {
            FORM_NAME,
            LISTED_TARGET,
            LISTED_SENTIMENT,
            columns: columns(this),
            options: {
                secondTargets:[],
                thirdTargets:[]
            },
            sources: {
                //双向绑定字段
                shown: false,
                sentimentData: null
            },
            list:{
               dimensionInfo: []
            }
        };
    },
    async mounted(){
        await this.refreshsecondTarget()
    },
    methods: {
        async refreshfirstTarget(params = this.$route.params){
            const firstTarget = await this.$$active(LISTED_TARGET, 'firstTarget',{ type:'listed', ...params, targetType: 0 })
            if(firstTarget)  this.options.firstTargets = firstTarget.data
        },
        async refreshsecondTarget(params = this.$route.params){
            const secondTarget = await this.$$active(LISTED_TARGET, 'secondTarget',{ type:'listed', ...params, targetType: 0 })
            if(secondTarget)  this.options.secondTargets = secondTarget.data
        },
        async refreshthirdTarget(params = this.$route.params){
            const thirdTarget = await this.$$active(LISTED_TARGET, 'thirdTarget',{ type:'listed', ...params, targetType: 0 })
            if(thirdTarget)  this.options.thirdTargets = thirdTarget.data
        },
        async UpdateThirdTargetNum(){
            if(!this.sources.sentimentData.thirdTargetNum || this.sources.sentimentData.thirdTargetNum == '待定') return;
            let data = {
                id: this.sources.sentimentData.id,
                thirdTargetNum: this.sources.sentimentData.thirdTargetNum
            }
            const result = await this.$$active(LISTED_SENTIMENT, 'thirdTargetNum',data)
            this.list = result.data[0]
        },
        handleAdd() {
            this.tagsList.push(this.addVal);
            this.addVal = "";
        },
        handleClose(event, name) {
            const index = this.tagsList.indexOf(name);
            this.tagsList.splice(index, 1);
        },
        onCancel() {
            // this.sources.result = this.value;
            this.$emit('refresh')
            this.hide();
        },
        async onSuccess(){
            const validate = await this.$refs[FORM_NAME].validate();
            if (!validate) {
                this.$$warning('表单验证不通过，请继续填写。');
                return Promise.reject(new Error('表单验证不通过，请继续填写。'));
            }
            this.options.validation.errors.value = ""
            this.$$loading(LISTED_TARGET)
            const result = await this.$$active(LISTED_TARGET, 'save', { type: this.type, ...this.sources.sentimentData })

            if([BusinessError, RequestError, Error].indexOf(result.constructor) == -1){
                this.$$loaded(LISTED_TARGET)
                //保存至本地并切换下一个指标

                this.$$success(`${ this.sources.sentimentData.secondTargetName}指标保存成功`)
                this.hide();
                this.$emit('input', result);
            }
            this.$emit('refresh');
            this.$$loaded(LISTED_TARGET)
        },
        hide() {
            this.sources.shown = false;
            this.$emit("shown-changed", this.sources.shown);
        },
        async dimension(item,score){
            var data = {
                id: this.sources.sentimentData.id,
                dimensionInfo : [
                   {
                     dimensionId: item.dimensionId,
                     dimensionScore: score
                   }
                ]
            }
            const result = await this.$$active(LISTED_SENTIMENT, 'dimension',data)
        }
    },
    computed: {
        repeatDataUnit() {
            return (this.sources.sentimentData && this.sources.sentimentData.targetUnit)
                ? this.sources.sentimentData.targetUnit
                : "--";
        },
    }
};
</script>
<style lang="scss" scoped>
.adm-content-item {
  font-size: 12px;
  padding: 5px 10px;
  color: #999999;
  .search-text {
    color: #e94949;
  }
  &__title {
    font-size: 12px;
    margin-bottom: 0.5em;
    h5{
      display: inline;
    }
    small {
      color: #aaa;
      font-weight: normal;
      margin-left: 0.625em;
    }
    .item_edit {
      color: #2d8cf0;
      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>
